import { get } from '@/assets/Api';
const user = {
    state: {
        token: '',
        userId: '',
        userName: '',
        nickName: '',
        operator: '', // 操作人
        avatar: '',
        isAdmin: null,
        roles: [], // 角色
        permissions: [], // 权限
        roleId:'',
    },
    mutations: {
        SET_TOKEN(state, data) {
            state.token = data;
        },
        SET_USERID(state, data) {
            state.userId = data;
        },
        SET_USERNAME(state, data) {
            state.userName = data;
        },
        SET_NICKNAME(state, data) {
            state.nickName = data;
        },
        SET_ROLES(state,data) {
            state.roles = data;
        },
        SET_PERMISSIONS(state,data) {
            state.permissions = data;
        },
        SET_OPERATOR(state, data) {
            state.operator = data;
        },
        SET_AVATAR(state, data) {
            state.avatar = data;
        },
        SET_IS_ADMIN(state, data) {
            state.isAdmin = data;
        },
        SET_ROLEID(state, data){
            state.roleId = data;

        }
    },
    actions: {
        getUserInfo({ state, rootState, commit, dispatch, getters }) {
            return new Promise((resolve, reject) => {
                get('system/user/getInfo').then(
                    res => {
                        if (!res) {
                            reject(false);
                            return;
                        }
                        let data_ = res.data;

                        commit('SET_USERID', data_.user.userId);
                        commit('SET_USERNAME', data_.user.userName);
                        commit('SET_NICKNAME', data_.user.nickName);
                        commit('SET_OPERATOR', data_.user.operator || '');
                        commit('SET_AVATAR', data_.user.avatar);
                        commit('SET_IS_ADMIN', data_.user.admin);
                        commit("SET_ROLES",data_.roles);
                        commit("SET_PERMISSIONS",data_.permissions);
                        commit("SET_ROLEID",data_.user.roleId);

                        resolve(state);
                    },
                    err => {
                        reject(err);
                    }
                );
            });
        },
    },
};

export default user;
